<script setup lang="ts">
import { UnicheckDeviceDto, UnicheckSimulatorDto } from '@/api/generator';
import DeviceState from '@/components/deviceStatus/DeviceState.vue';
import EntityChange from '@/components/EntityHistory/EntityChange.vue';
import {
  getEntityChangeEvent,
  MayHaveAnyEntityChangeEvent,
} from '@/components/EntityHistory/entityChange';
import { isIOTDevice } from '@/utils/rtSystem';
import { MayHaveState, useEntityState } from '@/utils/useEntityState';
import { computed, toRef } from 'vue';

const props = defineProps<{
  entity?: MayHaveAnyEntityChangeEvent & MayHaveState;
  showUsageCase?: boolean;
}>();

const { entityState, label } = useEntityState(toRef(() => props.entity));

const iotDeviceEntity = computed(() =>
  props.entity && isIOTDevice(props.entity as any)
    ? (props.entity as unknown as UnicheckDeviceDto | UnicheckSimulatorDto)
    : undefined,
);

const showIotStateAndBattery = computed(
  () =>
    iotDeviceEntity.value?.isAvailable &&
    iotDeviceEntity.value?.registrationState === 'Registered' &&
    entityState.value !== 'other',
);
</script>

<template>
  <div data-testid="basePageStatus" class="bar" :class="`bg-state-of-use-${entityState}`">
    <div class="text-body-1">
      <span class="caption mr-1">
        <slot name="title"> {{ $t('StateOfUse') }}: </slot>
      </span>

      <span class="caption" aria-label="stateOfUse"> {{ label }} </span>

      <EntityChange
        v-if="entity?.state && entity.state !== 'New'"
        :entityChange="getEntityChangeEvent(entity, 'editing')"
        :showEmptyFieldSign="false"
        singleLine
        class="white-text"
      />
    </div>

    <DeviceState
      v-if="iotDeviceEntity && showIotStateAndBattery"
      :deviceId="iotDeviceEntity.id"
      orientation="horizontal"
      showConnectedArray
      :subCategory="iotDeviceEntity.subCategory"
    />
  </div>
</template>

<style lang="scss" scoped>
.bar {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 24px;
  height: 24px;
  background: #ccc;
  color: rgb(var(--v-theme-off-white));
}

.caption {
  font-weight: 600;
  vertical-align: center;
}
</style>
